import ArticleInsightBearish from '@static/images/chart/article_insight_bearish.svg';
import ArticleInsightBearishDisabled from '@static/images/chart/article_insight_bearish_disabled.svg';
import ArticleInsightBullish from '@static/images/chart/article_insight_bullish.svg';
import ArticleInsightBullishDisabled from '@static/images/chart/article_insight_bullish_disabled.svg';
import { TooltipTrigger } from '@toggle/design-system';
import { Insight, InsightDirection } from '@toggle/toggle';
import { isSameDay } from 'date-fns';
import React from 'react';

import { ChartInsightCard } from '~/views/turbo-chart/components/insights/chart-insight-card/ChartInsightCard';

import * as S from './InsightIcon.styles';

const ICON_WIDTH = 16;
const ICON_HEIGHT = 20;
const ICON_SCALE = 1.25;

const defaultTransform = `scale(1)`;
const activeTransform = `scale(${ICON_SCALE})`;

export const getInsightIcon = (isBullish: boolean, isDisabled: boolean) => {
  if (isBullish) {
    return isDisabled ? ArticleInsightBullishDisabled : ArticleInsightBullish;
  }

  return isDisabled ? ArticleInsightBearishDisabled : ArticleInsightBearish;
};

export type InsightsIconProps = {
  insight: Insight;
  setSelectedInsight: (insightId: string) => void;
  selectedInsight: string | undefined;
  setInsightsDrawerOpen: (open: boolean) => void;
  insightsDrawerOpen: boolean;
  isDisabled: boolean;
};

export const InsightsIcon = ({
  insight,
  setSelectedInsight,
  selectedInsight,
  setInsightsDrawerOpen,
  insightsDrawerOpen,
  isDisabled,
}: InsightsIconProps) => {
  const isBullish = insight.metadata.direction == InsightDirection.Bullish;
  const InsightIcon = getInsightIcon(isBullish, isDisabled);

  const insightToday = (insight: Insight): boolean => {
    const insightDate = insight.metadata.last_value_date ?? insight.created_at;
    return isSameDay(new Date(insightDate), new Date());
  };

  const isOpen = isDisabled
    ? false
    : insight.id === selectedInsight && !insightsDrawerOpen;
  return (
    <S.StyledTooltipContainer
      key={insight.id}
      inPortal
      placement="top"
      hasArrow={false}
      isOpen={isOpen}
      trigger={TooltipTrigger.Click}
      onClose={() => {
        setSelectedInsight('');
        setInsightsDrawerOpen(false);
      }}
      label={
        <ChartInsightCard
          insightDetails={{
            type: 'article',
            item: insight,
          }}
          onOpenDetails={() => setInsightsDrawerOpen(true)}
        />
      }
    >
      <S.InsightsIconContainer
        $isBearish={!isBullish}
        onClick={e => {
          e.stopPropagation();
          if (!isDisabled) {
            setSelectedInsight(insight.id);
          }
        }}
        onMouseOver={e => {
          if (!selectedInsight && !isDisabled) {
            e.currentTarget.style.transform = activeTransform;
          }
        }}
        onMouseLeave={e => (e.currentTarget.style.transform = defaultTransform)}
      >
        {insightToday(insight) && !isDisabled && (
          <S.NewInsightIndicator data-testid="insight-today-indicator" />
        )}
        <InsightIcon
          width={ICON_WIDTH}
          height={ICON_HEIGHT}
          viewBox={`0 0 ${ICON_WIDTH} ${ICON_HEIGHT}`}
        />
      </S.InsightsIconContainer>
    </S.StyledTooltipContainer>
  );
};
